<template>
  <div class="settings-security">
    <div class="settings-security__title">{{ $tr('settings.security.title') }}</div>

    <div class="settings-security__subtitle">
      {{ $tr('settings.security.passwords.title') }}
    </div>

    <p class="settings-security__description">
      {{ $tr('settings.security.passwords.description') }}
    </p>

    <div class="settings-security__form-item">
      <trigger
        v-model="is_password_expiry"
        :text="$tr('settings.security.passwords.passwordChanges')"
        @input="setPasswordExpiry"
      />
    </div>

    <div class="settings-security__form-item">
      <trigger
        v-model="is_unique_password"
        :text="$tr('settings.security.passwords.restrictLast10Passwords')"
        @input="setUniquePassword"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Trigger from '@/components/shared/Trigger';

export default {
  name: 'SettingsSecurity',

  components: { Trigger },

  data() {
    return {
      is_password_expiry: false,
      is_unique_password: false
    };
  },

  computed: {
    ...mapState('company', ['company'])
  },

  async mounted() {
    await this.fetch();

    this.is_password_expiry = this.company.is_password_expiry;
    this.is_unique_password = this.company.is_unique_password;
  },

  methods: {
    ...mapActions('company', ['fetch', 'save']),

    setPasswordExpiry() {
      this.setPasswordRestriction('is_password_expiry');
    },

    setUniquePassword() {
      this.setPasswordRestriction('is_unique_password');
    },

    async setPasswordRestriction(param) {
      await this.save({ model: Object.assign({}, this.company, { [param]: this[param] }) });
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/fonts.scss';

.settings-security {
  max-width: 600px;

  &__title {
    @include mixin-text-header-bigger;
    margin-bottom: 20px;
  }

  &__subtitle {
    @include mixin-text-header-big;
    margin-bottom: 10px;
  }

  &__description {
    @include mixin-text-main;
    margin-bottom: 20px;
  }

  &__form-item {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
  }
}
</style>
